<div *ngIf="this.router.url !== '/contact-us'">
  <div class="help-support-main ">
    <div class="container">
      <div class="row mx-0">
        <div class="col-md-8">
          <div class="help-left d-sm-flex justify-content-sm-between">
            <div class="help-col">
              <h4>Help & Support</h4>
              <p>Facing trouble using our product? You could reach out to us on:</p>
            </div>
            <div class="help-col">
              <div class="details">
                <a (click)="analyticsService?.triggerSupportContactEvent(9999933039,'Help & Support')"
                  href="tel:9999933039">
                  <div class="img-box">
                    <img loading="lazy" src="{{environment?.blobUrl}}/assets/images/contact-us/phone.svg" alt="Phone | Luminous">
                  </div>
                  <div class="content">
                    <p>
                      9999933039
                    </p>
                    <span>9:00AM to 6:00PM</span>
                  </div>
                </a>
              </div>
              <div class="details">
               <a role="button"
                 (click)="analyticsService?.triggerSupportContactEvent(7042833939,'Help & Support')"
                 href="https://api.whatsapp.com/send?phone=7042833939"
                 target="_blank">
                  <div class="img-box">
                    <img loading="lazy" src="{{environment?.blobUrl}}/assets/images/contact-us/chat.svg" alt="Chat | Luminous">
                  </div>
                  <div class="content">
                    <p>
                      +91-7042833939
                    </p>
                  </div>
                </a>
              </div>
              <div class="details">
                <a (click)="analyticsService?.triggerSupportContactEvent('care@luminousindia.com','Help & Support')"
                  href="mailto:care@luminousindia.com">
                  <div class="img-box">
                    <img loading="lazy" src="{{environment?.blobUrl}}/assets/images/contact-us/email.svg" alt="Email | Luminous">
                  </div>
                  <div class="content">
                    <p>
                      care&#64;luminousindia.com
                    </p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="help-right d-md-flex align-items-md-center">
            <ul>
              <li>
                <a class="d-flex arrow" [routerLink]="['/enquiry']">
                 <img loading="lazy" [src]="environment?.blobUrl + '/assets/images/customer-support/register.svg'" alt="Business Enquiry | Luminous">
                  <p>Business Enquiry</p>
                </a>
              </li>
              <li>
                <a class="d-flex arrow" [routerLink]="['/book-complaint']">
                 <img loading="lazy" [src]="environment?.blobUrl + '/assets/images/customer-support/complaint-icon.svg'" alt="Complaint | Luminous">
                  <p>Book a complaint</p>
                </a>
              </li>
              <li>
                <a class="d-flex arrow" [routerLink]="['/warranty-registration']">
                 <img loading="lazy"[src]="environment?.blobUrl + '/assets/images/customer-support/register.svg'" alt="Register | Luminous">
                  <p>Register your product</p>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="this.router.url == '/contact-us'">
  <div class="supporthelp-wrap">
    <div class="container">
      <div class="supporthelp">
        <div class="row">
          <div class="col-md-4">
            <div class="content">
              <h3>Help & Support</h3>
              <p>Reach out to us and our support team will assist you</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="help-col">
              <div class="head">
                 <img  loading="lazy" [src]="environment?.blobUrl+'/assets/images/contact-us/email.svg'" alt="Email | Luminous">
                <p>Email Us</p>
              </div>
              <div class="details">
                <a href="mailto:connect@luminousindia.com">
                  <span>Buy Luminous products</span>
                  <p>connect&#64;luminousindia.com</p>
                </a>
              </div>
              <div class="details">
                <a href="mailto:sales@luminous-global.com">
                  <span>For all global queries</span>
                  <p>sales&#64;luminous-global.com</p>
                </a>
              </div>
              <div class="details">
                <a href="mailto:care@luminousindia.com">
                  <span>For after-sales support</span>
                  <p>care&#64;luminousindia.com</p>
                </a>
              </div>
              <div class="details">
                <a href="mailto:energysolution@luminousindia.com">
                  <span>For Energy Solutions</span>
                  <p>energysolution&#64;luminousindia.com</p>
                </a>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="help-col">
              <div class="help-right d-md-flex flex-md-column justify-content-md-between">
                <div>
                  <div class="head">
                     <img  loading="lazy" [src]="environment?.blobUrl+'/assets/images/contact-us/chat.svg'" alt="Chat | Luminous">
                    <p>Chat with us</p>
                  </div>
                 
                  <div class="details">
                    <a target="_blank" (click)="analyticsService?.trackContactUs()"
                      href="https://api.whatsapp.com/send?phone=7042833939">
                      <!-- <span>After-sales</span> -->
                      <p>+91-7042833939</p>
                    </a>
                  </div>
                  <!-- <div class="details">
                    <a target="_blank" (click)="analyticsService?.trackContactUs()"
                      href="https://api.whatsapp.com/send?phone=9990299902">
                      <span>Solar Solutions</span>
                      <p>9990299902</p>
                    </a>
                  </div> -->
                </div>
                <div>
                  <div class="head">
                     <img  loading="lazy" [src]="environment?.blobUrl+'/assets/images/contact-us/phone.svg'" alt="Phone | Luminous">
                    <p>Call us</p>
                  </div>
                  <div class="details">
                    <a (click)="analyticsService?.trackContactUs()" href="tel:9999933039">
                      <span>Customer Care Help Line</span>
                      <p>9999933039</p>
                    </a>
                  </div>
                   <div class="details">
                    <a target="_blank" (click)="analyticsService?.trackContactUs()"
                      href="https://api.whatsapp.com/send?phone=8906008008">
                      <span>Buy Luminous Products</span>
                      <p>+91-8906008008</p>
                    </a>
                  </div>
                  <div class="details">
                    <a (click)="analyticsService?.trackContactUs()" href="tel:9990299902">
                      <span> For Energy Solutions</span>
                      <p>9990299902</p>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>